import { render } from "./PuxDatepicker.pug?vue&type=template&id=859a88d2&lang=pug"
import script from "./PuxDatepicker.js?vue&type=script&lang=js"
export * from "./PuxDatepicker.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__